const Icon = ({icon, ...rest}) => <i {...rest} className={icon} ></i> 

export default Icon;